/* eslint no-loop-func: off */
/* eslint no-continue: off */

import store from "../../store";
import {
  setMetaCardDiscountDataFromJunsi,
  setPayDiscountDataFromJunsi,
  setPointBenefitDataFromJunsi,
  setPromotionBannerFromJunsi,
} from "../../store/actionCreators/fetchApi";

/**
 * @export
 * @class Junsi
 * 전시관리 배너
 */
export default class Junsi {
  constructor() {
    this.callJunsiModule();
    this.dispatchJunsiData();
  }
  
  callJunsiModule() {
    const { viewAreaGetByDealNo } = TMON.oApp.htStorage;
    const viewAreaList = viewAreaGetByDealNo.data;
    if (!viewAreaList || !viewAreaList.length) {
      return;
    }

    const htProps = {
      aRenderCategory: [
        TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth1No,
        TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth2No,
        TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth3No,
        TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth4No,
      ],
      beforeMoveLinkCallApp: (
        sLink,
        sLinkInfomation,
        sLinkType,
        sMobileNavigationTitle,
        sMobileNavigationType
      ) => {
        const htDummyProps = {
          sLink,
          sLinkInfomation,
          sLinkType,
          sMobileNavigationTitle,
          sMobileNavigationType,
        };
        if (htDummyProps.sLinkType === 'DEAL') {
          location.href = htDummyProps.sLink;
          return false;
        }

        return true;
      },
      afterRender: (wel, { data }) => {
        const junsiArea = wel.find(`[data-vwa-code=${data.viewAreaCode}]`);
        const items = $(junsiArea).find('.vwa_item');
        if (items.length === 0) return;

        if (wel.data('bannertype') === 'rolling') {
          items.each((index, el) => {
            $(el)
              .attr('data-tlarea', wel.data('junsitlarea'))
              .attr('data-tlord', index + 1);
          });
          this.setRollingBanner(wel);
          return;
        }

        items.each((__, el) => {
          const item = $(el);
          const link = item.find('a');
          const innerImageAlt = link.find('.vwa_image_alt');
          if (innerImageAlt.length > 0 && link.length > 0) {
            item.attr(
              'data-tldimension',
              `36:${innerImageAlt.text()}`
            );
          }
          item.attr('data-tlarea', 'DBANNER');
        });
      },
    }

    const staticJunsiCodes = Object.values(TMON.htCommonStaticInfo.junsi)
    // 상품설명 영역 외에 보여야 하는 전시
    const staticJunsi = viewAreaList.filter((el) => staticJunsiCodes.includes(el.viewAreaCode));
    // 상품설명 영역 안에 보여야 하는 전시
    let dealContentJunsi = viewAreaList.filter((el) => !staticJunsiCodes.includes(el.viewAreaCode));

    // 로컬딜 일 때만 현장구매방지 배너 노출
    if (!TMON.htStaticData.bIsLocalDeal) {
      dealContentJunsi = dealContentJunsi.filter(
        (el) => el.viewAreaCode !== 'VWA_0250144646619226'
      );
    }
    // 아래 딜일 때 전시 바이러스 임시 배너 노출 안함
    const excludeDealNo = ['25036278254', '25086240342', '25036477286', '25260490070', '25261088346', '25237805990', '25260653766', '25260506914', '25261189350', '25237825410', '25260666286', '25335617530'];
    if (excludeDealNo.includes(TMON.htStaticData.sDealNo)) {
      dealContentJunsi = dealContentJunsi.filter(
        (el) => el.viewAreaCode !== 'VWA_1516820172428612'
      );
    }

    // DALL 타입 전시(모든 딜에 공통적으로 내려오는 전시 데이터)
    const typeDallJunsi = dealContentJunsi.filter((el) => el.viewAreaType === 'DALL');
    // DALL 타입이 아닌 전시(딜마다 다르게 설정되어 있는 전시 데이터)
    const typeNotDallJunsi = dealContentJunsi.filter((el) => el.viewAreaType !== 'DALL');

    // 상품설명 영역 외에 보여질 전시 렌더링(각 전시 데이터마다 전시 모듈을 호출한다.)
    for (const viewArea of staticJunsi) {
      const { viewAreaCode } = viewArea;
      const welTargetArea = $(`[data-junsiCode="${viewAreaCode}"]`).eq(0);
      if (!welTargetArea) continue;

      welTargetArea.junsi({...htProps, htData: { data: viewArea }});
    }

    // 상품설명 안에 보여질 전시 렌더링(전시 데이터들을 배열에 담아 전시 모듈을 한번만 호출한다.)
    const welDallArea = $(`#description [data-junsiType="DALL"]`).eq(0);
    welDallArea.junsi({...htProps, htData: { data: typeDallJunsi }});

    // DALL 타입이 아닌 데이터 전시 모듈 호출(전시 데이터들을 배열에 담아 전시 모듈을 한번만 호출한다.)
    const welNotDallArea = $(`[data-junsiType="NOT_DALL"]`).eq(0);
    welNotDallArea.junsi({...htProps, htData: { data: typeNotDallJunsi } });
  };

  /*
  * 돔에 렌더하는 것 없이 전시 데이터를 리덕스에 넣는 함수
  */
  dispatchJunsiData() {
    const { viewAreaGetByDealNo } = TMON.oApp.htStorage;
    const viewAreaList = viewAreaGetByDealNo.data;
    if (!viewAreaList || !viewAreaList.length) {
      return;
    }
  
    const { junsi } = TMON.htCommonStaticInfo;
    const tasks = [
      // [SDLUI-2001] 적립혜택
      {
        viewAreaCode: junsi.pointBenefitJunsiCode,
        actionCreator: setPointBenefitDataFromJunsi
      }, 
      // [SDLUI-2001] 결제혜택
      {
        viewAreaCode: junsi.payDiscountJunsiCode,
        actionCreator: setPayDiscountDataFromJunsi
      },
      // 프로모션 배너
      {
        viewAreaCode: junsi.promotionBannerJunsiCode,
        actionCreator: setPromotionBannerFromJunsi
      }, 
      // [TWORK-1423] 메타 청구할인가
      {
        viewAreaCode: junsi.metaCardDiscountJunsiCode,
        actionCreator: setMetaCardDiscountDataFromJunsi
      }, 
    ];

    for (const task of tasks) {
      const { actionCreator, viewAreaCode } = task;
      store.dispatch(
        actionCreator({
          data: viewAreaList.find(
            (el) => el.viewAreaCode === viewAreaCode
          ),
        })
      );
    }
  }

  setRollingBanner(wel) {
    const vwaInfo = wel.find('.vwa_info:first');
    const vwaItems = vwaInfo.find('.vwa_item');
    const prevButton = wel.find('.ctrl #prev');
    const nextButton = wel.find('.ctrl #next');
    const images = wel.find('img');
    let curBannerIndex = 0;

    // 이미지가 없을 경우 영역 자체를 제거
    if (images.length === 0) {
      wel.remove();
      return;
    }

    // 실제 노출되는 이미지는 첫 번째 vwa_info에만 있다.
    wel
      .find('.vwa_info')
      .not(':first')
      .remove();

    const showBanner = () => {
      vwaItems
        .stop()
        .css('position', 'absolute')
        .fadeOut();
      vwaItems
        .eq(curBannerIndex)
        .stop()
        .css('position', 'relative')
        .fadeIn();
    };

    const prevBanner = () => {
      if (curBannerIndex !== 0) {
        curBannerIndex -= 1;
      } else {
        curBannerIndex = vwaItems.length - 1;
      }
      showBanner();
    };

    const nextBanner = () => {
      if (curBannerIndex < vwaItems.length - 1) {
        curBannerIndex += 1;
      } else {
        curBannerIndex = 0;
      }
      showBanner();
    };

    // 타이머의 Id를 배너 각각마다 가지고 있어야 하므로 data에 저장한다.
    const startTimer = () => {
      const timerId = wel.data('timerId');
      if (timerId) {
        clearInterval(timerId);
      }

      const tempTimerId = setInterval(() => {
        nextBanner();
      }, 3000);
      wel.data('timerId', tempTimerId);
    };

    prevButton.click(() => {
      prevBanner();
      startTimer();
    });

    nextButton.click(() => {
      nextBanner();
      startTimer();
    });

    if (!vwaItems.length) {
      return;
    }

    vwaItems.css('position', 'absolute').hide();
    vwaItems
      .eq(curBannerIndex)
      .css('position', 'relative')
      .show();

    if (vwaItems.length > 1) {
      prevButton.show();
      nextButton.show();

      startTimer();
    }
  }
}
